import React from 'react';
import { ToolbarContainer, ToolbarButton } from '../Common/StyledComponents';
import Icon from '../Common/Icon';

const ActionToolbar = ({ onMoveUp, onMoveDown, onRemove }) => {
  return (
    <ToolbarContainer>
      <ToolbarButton variant="orange" onClick={onMoveUp} title="Move Up"><Icon name="moveUp" color="white" /></ToolbarButton>
      <ToolbarButton variant="orange" onClick={onMoveDown} title="Move Down"><Icon name="moveDown" color="white" /></ToolbarButton>
      <ToolbarButton variant="red" onClick={onRemove} title="Remove"><Icon name="delete" color="#ffffff" /></ToolbarButton>
    </ToolbarContainer>
  );
};

export default ActionToolbar;